import { render } from "./ProductsCarousel.vue?vue&type=template&id=6d95daa2&scoped=true"
import script from "./ProductsCarousel.vue?vue&type=script&lang=js"
export * from "./ProductsCarousel.vue?vue&type=script&lang=js"

import "./ProductsCarousel.vue?vue&type=style&index=0&id=6d95daa2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d95daa2"]])

export default __exports__